module.exports = __webpack_public_path__ + "img/r2.a856e941.png";